import { CircleCheckBigIcon, Heading, Text } from '@buffer-mono/popcorn'
import * as m from 'motion/react-m'

import styles from './AllSetMessage.module.css'

import type { JSX } from 'react'

export function AllSetMessage(): JSX.Element {
  return (
    <div className={styles.root} aria-live="polite">
      <span className={styles.animationContainer} aria-hidden>
        <m.span
          className={styles.iconBadge}
          animate={{
            scale: [1, 1.2, 1],
            transition: { duration: 1 },
            backgroundColor: [
              'var(--color-bg-success-subtle)',
              'var(--global-color-green-300)',
              'var(--color-bg-success-subtle)',
            ],
          }}
        />
        <CircleCheckBigIcon
          className={styles.checkCircleIcon}
          color="success"
          size="large"
        />
      </span>
      <Heading as="h2" size="xs">
        You&rsquo;re all set 🎉
      </Heading>
      <Text size="sm" color="subtle">
        Getting your next steps ready…
      </Text>
    </div>
  )
}
